import React from "react";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import { variableUseMutation } from "../hooks";
import { EntityRemoveButton, Localize, UploadFile } from "components/service";
import { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import Icons from "components/icons";
import { usePermissionByObject, useIsDeveloper } from "components/permissions";
import VariableConst from "components/variable/variable-const";

interface IVariableActionFieldProps
{
    variableList: {
        id: string;
        slug: string;
        group_name: string;
    };
    variables: {
        [ key: string ]: any;
    };
}

const VariableActionField: React.FC<IVariableActionFieldProps> = ({ variableList: { id, slug, group_name }, variables }) =>
{
    const { _setVariableUploadFile, loadingMutationVariableUploadFile } =
        variableUseMutation.uploadFile({ variables });

    const { _setMutationVariableDelete, loadingMutationVariableDelete } =
        variableUseMutation.delete(id);

    const { hasPermission: hasUpdateItemsPermission } = usePermissionByObject(VariableConst.permissions.UPDATE_ITEMS);
    const { hasPermission: hasDeleteItemsPermission } = usePermissionByObject(VariableConst.permissions.DELETE_ITEMS);
    const isDeveloper = useIsDeveloper();
    const canUpdateItems = isDeveloper || hasUpdateItemsPermission;
    const canDeleteItems = isDeveloper || hasDeleteItemsPermission;

    const items = [
        {
            key: "1",
            label: (
                <Tooltip title={!canUpdateItems ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(VariableConst.permissions.UPDATE_ITEMS.slug)}` : undefined}>
                    <div style={{ opacity: canUpdateItems ? 1 : 0.5 }}>
                        <UploadFile
                            setMutation={_setVariableUploadFile}
                            loading={loadingMutationVariableUploadFile}
                            accept="image/*"
                            varSetMutation={{
                                input: {
                                    model: "VariableList",
                                    model_id: id,
                                    model_field: "img_path",
                                },
                            }}
                            uploadBtn={
                                <div className="">
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        {loadingMutationVariableUploadFile ? (
                                            <Loading3QuartersOutlined spin />
                                        ) : (
                                            <Icons.Upload />
                                        )}{" "}
                                        <Localize>MENUS_DROP.Label_UploadIcon</Localize>
                                    </span>
                                </div>
                            }
                            disabled={!canUpdateItems}
                        />
                    </div>
                </Tooltip>
            ),
            disabled: !canUpdateItems,
            onClick: () => {
                if (!canUpdateItems) return;
                // UploadFile component handles the actual upload logic
            },
        },
        {
            key: "2",
            label: (
                <Tooltip title={!canDeleteItems ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(VariableConst.permissions.DELETE_ITEMS.slug)}` : undefined}>
                    <div style={{ opacity: canDeleteItems ? 1 : 0.5 }}>
                        <EntityRemoveButton
                            modalButton={
                                <span style={{ display: "flex", alignItems: "center" }}>
                                    <Icons.Delete />{" "}
                                    <Localize>MENUS_DROP.Label_Delete</Localize>
                                </span>
                            }
                            nameEntity={
                                localizeByKey("ENTITY.Modal_Title_Key")
                            }
                            dataNameEntity={slug}
                            loading={loadingMutationVariableDelete}
                            deleteMutation={(options) => {
                                if (!canDeleteItems) {
                                    return Promise.reject(new Error('Access denied'));
                                }
                                return _setMutationVariableDelete(options);
                            }}
                            variables={{
                                group_name,
                                slug,
                            }}
                        />
                    </div>
                </Tooltip>
            ),
            disabled: !canDeleteItems,
        },
    ];

    return (
        <Dropdown
            // trigger={['click']}
            placement="bottomRight"
            menu={{ items }}
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    );
};

export default VariableActionField;